import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

export default function ThankYouPage() {
    // Italian only, per spec
    React.useEffect(() => {
        i18n.changeLanguage("it");
        document.documentElement.setAttribute("lang", "it");
        document.title = "Grazie — Auronixra";
    }, []);
    const { t } = useTranslation("thankyou");
    const infoItems = t("info_items", { returnObjects: true });

    return (
        <div className="aurx-thankyou" data-testid="thankyou-page">
            <div className="aurx-thankyou-inner">
                <div className="subtitle">{t("subtitle")}</div>
                <h1>{t("title")}</h1>
                <p>{t("body")}</p>

                <div className="aurx-thankyou-info">
                    <h3>{t("info_title")}</h3>
                    <ol>
                        {Object.keys(infoItems).map((k) => (
                            <li key={k}>{infoItems[k]}</li>
                        ))}
                    </ol>
                </div>

                <Link
                    to="/"
                    className="aurx-btn aurx-btn-gold"
                    data-testid="thankyou-back-home"
                >
                    <ArrowLeft size={16} />
                    {t("back_home")}
                </Link>

                <p className="aurx-thankyou-note">{t("footer_note")}</p>
            </div>
        </div>
    );
}
